import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PagedRequestDTO} from '../models/PagedRequestDTO';
import {PagedResponseDTO} from '../models/PagedResponseDTO';
import {IntegrationErrorMessageDTO} from '../models/IntegrationErrorMessageDTO';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegrationErrorMessageService {
  private ignUrlBaseUrl = environment.baseIgnUrl;

  constructor(private httpClient: HttpClient) {
  }

  getListOfIntegrationErrorMessages(payload: PagedRequestDTO): Observable<PagedResponseDTO<IntegrationErrorMessageDTO>> {
    return this.httpClient.post<PagedResponseDTO<IntegrationErrorMessageDTO>>(`${this.ignUrlBaseUrl}/message/filter`, payload);
  }

  getMessageById(id: number): Observable<IntegrationErrorMessageDTO> {
    return this.httpClient.get<IntegrationErrorMessageDTO>(`${this.ignUrlBaseUrl}/message/${id}`);
  }

}
